import { Controller } from "@hotwired/stimulus"

// Simple click-toggled dropdown that closes on outside click / Escape.
// Clicks *inside* the dropdown (e.g. the "Rows per page" <select>) are ignored
// so menu controls keep working without the panel snapping shut.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.keydown = (event) => { if (event.key === "Escape") this.close() }
  }

  disconnect() {
    this.stopListening()
  }

  toggle(event) {
    event.stopPropagation()
    const willOpen = this.menuTarget.classList.contains("hidden")
    this.menuTarget.classList.toggle("hidden", !willOpen)
    if (willOpen) {
      document.addEventListener("click", this.closeOnOutsideClick)
      document.addEventListener("keydown", this.keydown)
    } else {
      this.stopListening()
    }
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return
    this.close()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.stopListening()
  }

  stopListening() {
    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("keydown", this.keydown)
  }
}
